module.exports = __webpack_public_path__ + "static/media/warning-red-super.9c28f6d3.svg";